import { useEffect, useMemo, type ReactNode } from "react";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { getDesignTokens, setDocumentUiVariables } from "@eposnow/ui-core";
import { useUIContext } from "./UIContext";

function ThemeContext({ children }: { children: ReactNode }) {
  const { colorMode } = useUIContext();

  const theme = useMemo(
    () =>
      createTheme(getDesignTokens(colorMode) as Parameters<typeof createTheme>[0], {
        components: {
          MuiTab: {
            styleOverrides: {
              root: {
                textTransform: "none",
              },
            },
          },
        },
      }),
    [colorMode],
  );

  useEffect(() => {
    setDocumentUiVariables(colorMode);
  }, [colorMode]);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
}

export default ThemeContext;
